import React, { useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import "jspdf-autotable";
import { useNavigate } from "react-router-dom";

function Billing() {
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [invoiceData, setInvoiceData] = useState(null);
    const [fileData, setFileData] = useState(null);
    const [formData, setFormData] = useState({
        from_name: '',
        from_address1: '',
        from_address2: '',
        from_city: '',
        from_phone1: '',
        from_phone2: '',
        to_name: '',
        to_address1: '',
        to_address2: '',
        to_city: '',
        to_phone1: '',
        to_phone2: '',
        ref_reg_no: '',
        ref_vehicle_type: '',
        ref_vehicle_color: '',
        ref_amount: '',
        bike_model: '',
        bike_make: '',
        bike_color: '',
        bike_chase_no: '',
        bike_engine_no: '',
        payment_type1: '',
        payment_type2: '',
        cash_paid1: '',
        cash_paid2: '',
        balance: '',
        finance: '',
        emi_tenure: '',
        exchange_of: '',
        exchange_amout: '',
        exchange_reg_no: '',
        exchange_bike_model: '',
        exchange_bike_make: '',
        exchange_bike_color: '',
        exchange_bike_chase_no: '',
        exchange_bike_engine_no: '',
        bank_name: '',
    });
    const [loading, setLoading] = useState(true);

    const today = new Date();
    const formattedDate = today.toLocaleDateString("en-GB"); // Format as DD/MM/YYYY

    const [files, setFiles] = useState({
        aadhar_file: null,
        rc_file: null,
        photo_file: null,
        photowithbike_file: null,
    });

    const [errors, setErrors] = useState({
        from_name: '',
        from_address1: '',
        from_phone1: '',
        to_name: '',
        to_address1: '',
        to_phone1: '',
        ref_reg_no: '',
        ref_amount: '',
        payment_type1: '',
        cash_paid1: '',
        aadhar_file: "",
        rc_file: "",
        photo_file: "",
        photowithbike_file: "",
    });

    const allowedFormats = ["application/pdf", "image/jpeg", "image/png"];

    // Validation function
    const validateForm = () => {
        let formErrors = {}; // Store validation errors
        const phoneRegex = /^\d{10}$/; // Phone and WhatsApp validation regex (10 digits)


        // Check if required fields are empty (if a field is required, you can add custom logic here)
        if (!formData.from_name) {
            formErrors.from_name = "From Name is required";
        }

        if (!formData.from_address1) {
            formErrors.from_address1 = "From Address1 is required";
        }

        if (!formData.to_name) {
            formErrors.to_name = "To Name is required";
        }

        if (!formData.to_address1) {
            formErrors.to_address1 = "To Address1 is required";
        }


        if (!formData.ref_reg_no) {
            formErrors.ref_reg_no = "Register Number is required";
        }

        if (!formData.ref_amount) {
            formErrors.ref_amount = "Amount is required";
        }

        if (!formData.payment_type1) {
            formErrors.payment_type1 = "Payment Type is required";
        }

        if (!formData.cash_paid1) {
            formErrors.cash_paid1 = "Cash Paid is required";
        }

        if (!files.aadhar_file) {
            formErrors.aadhar_file = "Aadhaar is required";
        }

        if (!files.rc_file) {
            formErrors.rc_file = "Rc is required";
        }

        if (!files.photo_file) {
            formErrors.photo_file = "Photo is required";
        }

        if (!files.photowithbike_file) {
            formErrors.photowithbike_file = "Photo With Bike is required";
        }

        // Check phone numbers

        if (!phoneRegex.test(formData.to_phone1)) {
            formErrors.to_phone1 = 'Please enter a valid 10-digit phone number';
        }

        // If there are errors, set them in the state and return false
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors); // Store the errors in the state
            return false; // Validation failed
        }

        // Return true if no errors
        return true;
    };

    // Handle form input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleFileChange = (e) => {
        const { id, files } = e.target;
        const file = files[0];

        if (file) {
            const { type, size } = file;

            // Validate file format
            if (!allowedFormats.includes(type)) {
                setErrors((prev) => ({
                    ...prev,
                    [id]: "Invalid file type! Only PDF, JPG, and PNG allowed.",
                }));
                setFiles((prev) => ({ ...prev, [id]: null }));
                return;
            }

            // Validate file size
            if (
                (type === "application/pdf" && size > 100 * 1024) ||
                ((type === "image/jpeg" || type === "image/png") && size > 50 * 1024)
            ) {
                setErrors((prev) => ({
                    ...prev,
                    [id]: `File too large! Max size: ${type === "application/pdf" ? "100KB (PDF)" : "50KB (Image)"
                        }`,
                }));
                setFiles((prev) => ({ ...prev, [id]: null }));
                return;
            }

            // Clear errors and set file
            setErrors((prev) => ({ ...prev, [id]: "" }));
            setFiles((prev) => ({ ...prev, [id]: file }));
        }
    };

    const printBill = () => {
        const printContents = document.getElementById("download_section").innerHTML;
        const originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;  // Replace body content with invoice
        window.print();  // Trigger the print dialog
        // Instead of restoring innerHTML manually, reload the page
        window.location.reload();
    };

    const savebilling = async (event) => {
        event.preventDefault();

        // Prevent multiple submissions
        if (isSaving || isSaved) return;

        if (validateForm()) {
            setIsSaving(true); // Disable the button

            setLoading(true);
            setErrors({});

            try {
                // Get current date and time
                const currentDate = new Date();

                // Format date as YYYY-MM-DD
                const formattedDate = currentDate.toISOString().split('T')[0];

                // Format date and time as YYYY-MM-DD HH:MM:SS
                function getISTDateTime12Hour() {
                    const options = {
                        timeZone: 'Asia/Kolkata',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: true
                    };

                    const now = new Date();
                    const timePart = new Intl.DateTimeFormat('en-US', options).format(now);

                    // Extract Indian date in DD/MM/YYYY format
                    const day = now.toLocaleString('en-IN', { day: '2-digit', timeZone: 'Asia/Kolkata' });
                    const month = now.toLocaleString('en-IN', { month: '2-digit', timeZone: 'Asia/Kolkata' });
                    const year = now.toLocaleString('en-IN', { year: 'numeric', timeZone: 'Asia/Kolkata' });

                    return `${day}/${month}/${year}, ${timePart}`;
                }

                const formattedDateTime = getISTDateTime12Hour();
                console.log("IST Time:", formattedDateTime);
                // Get user ID from localStorage
                const created_by = localStorage.getItem('user_id');
                let billingId = "";
                let amt_in_words = "";

                // Add new fields to formData
                const updatedFormData = {
                    ...formData,
                    date: formattedDate,        // Stores only the date
                    ref_time: formattedDateTime,     // Stores both date and time
                    created_by: created_by,
                };
                console.log(updatedFormData)
                // Step 1: Save form data to billing API

                try {
                    const formResponse = await axios.post('https://api.sivammoto.in/api/billing/add', updatedFormData);
                    console.log(formResponse.data.billing_id)
                    billingId = formResponse.data.billing_id; // Get billing ID
                    amt_in_words = formResponse.data.amt_in_words;

                    const finaldata = {
                        ...updatedFormData,
                        bill_no: billingId,
                        ref_amountinwords: amt_in_words,      // Stores billingid to updatedfordata
                    };
                    setInvoiceData(finaldata);
                }
                catch (error) {
                    console.error('Error saving data:', error);
                    // Extract error message from API response
                    let errorMessage = 'There was an issue in saving the record.';
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message; // Get error message from backend response
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Error!',
                        text: errorMessage,
                    });
                }

                console.log(billingId)


                try {
                    if (billingId) {
                        // Step 2: Save file data with billing_id
                        const formDataWithFile = new FormData();
                        formDataWithFile.append("billing_id", billingId); // Send billing ID
                        formDataWithFile.append("created_by", 1); // Send user ID (or get from session)
                        formDataWithFile.append("rc_file", files.rc_file);
                        formDataWithFile.append("aadhar_file", files.aadhar_file);
                        formDataWithFile.append("photo_file", files.photo_file);
                        formDataWithFile.append("photowithbike_file", files.photowithbike_file);

                        const fileResponse = await axios.post("https://api.sivammoto.in/api/file/upload", formDataWithFile,
                            { headers: { "Content-Type": "multipart/form-data" } }
                        );
                        setFileData(fileResponse.data);
                        // Wait for state to update before logging
                        setTimeout(() => {
                            console.log("Updated fileData:", fileData);
                        }, 500);
                        setIsSaved(true);
                        Swal.fire('Saved!', 'Form and file saved successfully', 'success');

                    }

                }
                catch (error) {
                    console.error('Error saving File:', error);
                    // Extract error message from API response
                    let errorMessage = 'There was an issue in saving the record.';
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message; // Get error message from backend response
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Error saving File!',
                        text: errorMessage,
                    });
                }

                // Success
                //alert('Form and file saved successfully');
                //Swal.fire('Saved!', 'Form and file saved successfully', 'success');


            } catch (error) {
                setErrors((prev) => ({ ...prev, form: error.message }));
            } finally {
                setLoading(false);
            }
            setIsSaving(false); // Re-enable the button
        }
    };

    const handleClear = () => {
        setInvoiceData({});
        setFileData({});
        setFiles([]);
        setErrors({});

        // Navigate without reload
        navigate("/dailyreport", { replace: true });
    };


    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Daily Report</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section class="content">
                <div class="container-fluid">

                    <div class="row">
                        <div class="col-md-12">
                            <div class="card card-maroon">
                                <div class="card-header">
                                    <h3 class="card-title">Billing</h3>
                                </div>
                                <form onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                    }
                                }}>
                                    <div class="card-body">
                                        <label for="from">From:</label>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="from_name">Name</label>
                                                    <input type="text" class="form-control" value={formData.from_name} onChange={handleInputChange} name="from_name" placeholder="Enter Name" />
                                                    {errors.from_name && <small className="text-danger">{errors.from_name}</small>}
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="from_address1">Address Line 1</label>
                                                    <input type="text" class="form-control" value={formData.from_address1} onChange={handleInputChange} name="from_address1" placeholder="Enter Address" />
                                                    {errors.from_address1 && <small className="text-danger">{errors.from_address1}</small>}
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="from_address2">Address Line 2</label>
                                                    <input type="text" class="form-control" value={formData.from_address2} onChange={handleInputChange} name="from_address2" placeholder="Enter Address Line 2" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="from_city">City / District</label>
                                                    <input type="text" class="form-control" value={formData.from_city} onChange={handleInputChange} name="from_city" placeholder="Enter City / District" />
                                                </div>
                                            </div>
                                        </div>

                                        <label for="to">To:</label>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="to_name">Name</label>
                                                    <input type="text" class="form-control" value={formData.to_name} onChange={handleInputChange} name="to_name" placeholder="Enter Name" />
                                                    {errors.to_name && <small className="text-danger">{errors.to_name}</small>}
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="to_address1">Address Line 1</label>
                                                    <input type="text" class="form-control" value={formData.to_address1} onChange={handleInputChange} name="to_address1" placeholder="Enter Address" />
                                                    {errors.to_address1 && <small className="text-danger">{errors.to_address1}</small>}
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="to_address2">Address Line 2</label>
                                                    <input type="text" class="form-control" value={formData.to_address2} onChange={handleInputChange} name="to_address2" placeholder="Enter Address Line 2" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="to_city">City / District</label>
                                                    <input type="text" class="form-control" value={formData.to_city} onChange={handleInputChange} name="to_city" placeholder="Enter City / District" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="to_phone1">Primary Phone</label>
                                                    <input type="text" class="form-control" value={formData.to_phone1} onChange={handleInputChange} name="to_phone1" placeholder="Enter Phone Number" />
                                                    {errors.to_phone1 && <small className="text-danger">{errors.to_phone1}</small>}

                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="to_phone2">Alternate Phone</label>
                                                    <input type="text" class="form-control" value={formData.to_phone2} onChange={handleInputChange} name="to_phone2" placeholder="Enter Phone Number" />
                                                </div>
                                            </div>
                                        </div>

                                        <hr class="divider"></hr>

                                        <label for="from">Ref:</label>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="ref_reg_no">Registration No</label>
                                                    <input type="text" class="form-control" value={formData.ref_reg_no} onChange={handleInputChange} name="ref_reg_no" placeholder="Enter Registration No" />
                                                    {errors.ref_reg_no && <small className="text-danger">{errors.ref_reg_no}</small>}
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="ref_vehicle_type">Vehicle Type</label>
                                                    <input type="text" class="form-control" value={formData.ref_vehicle_type} onChange={handleInputChange} name="ref_vehicle_type" placeholder="Enter Vehicle Type" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="ref_vehicle_color">Vehicle Color</label>
                                                    <input type="text" class="form-control" value={formData.ref_vehicle_color} onChange={handleInputChange} name="ref_vehicle_color" placeholder="Enter Vehicle Color" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="ref_amount">Amount</label>
                                                    <input type="text" class="form-control" value={formData.ref_amount} onChange={handleInputChange} name="ref_amount" placeholder="Enter Amount" />
                                                    {errors.ref_amount && <small className="text-danger">{errors.ref_amount}</small>}
                                                </div>
                                            </div>
                                        </div>

                                        <hr class="divider"></hr>

                                        <label for="from">Vehicle Details:</label>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="bike_model">Model</label>
                                                    <input type="text" class="form-control" value={formData.bike_model} onChange={handleInputChange} name="bike_model" placeholder="Enter Model" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="bike_make">Make</label>
                                                    <input type="text" class="form-control" value={formData.bike_make} onChange={handleInputChange} name="bike_make" placeholder="Enter Make" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="bike_chase_no">Chase No</label>
                                                    <input type="text" class="form-control" value={formData.bike_chase_no} onChange={handleInputChange} name="bike_chase_no" placeholder="Enter Chase No" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="bike_engine_no">Engine No</label>
                                                    <input type="text" class="form-control" value={formData.bike_engine_no} onChange={handleInputChange} name="bike_engine_no" placeholder="Enter Chase No" />
                                                </div>
                                            </div>
                                        </div>

                                        <hr class="divider"></hr>

                                        <label for="from">Finance Details:</label>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="payment_type1">Primary Payment Type</label>
                                                    <select className="form-control select2" style={{ width: "100%", borderColor: "black" }} name="payment_type1" value={formData.payment_type1} onChange={handleInputChange} >
                                                        <option value="" disabled>Select Primary Payment Type</option>
                                                        <option value="Cash">Cash</option>
                                                        <option value="Card">Card</option>
                                                        <option value="UPI">UPI</option>
                                                    </select>
                                                    {errors.payment_type1 && <small className="text-danger">{errors.payment_type1}</small>}
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="cash_paid1">Primary Cash Amount</label>
                                                    <input type="text" class="form-control" value={formData.cash_paid1} onChange={handleInputChange} name="cash_paid1" placeholder="Enter Primary Cash Amount" />
                                                    {errors.cash_paid1 && <small className="text-danger">{errors.cash_paid1}</small>}
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="payment_type2">Secondary Payment Type</label>
                                                    <select className="form-control select2" style={{ width: "100%", borderColor: "black" }} name="payment_type2" value={formData.payment_type2} onChange={handleInputChange} >
                                                        <option value="" disabled>Select Secondary Payment Type</option>
                                                        <option value="Cash">Cash</option>
                                                        <option value="Card">Card</option>
                                                        <option value="UPI">UPI</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="cash_paid2">Secondary Cash Amount</label>
                                                    <input type="text" class="form-control" value={formData.cash_paid2} onChange={handleInputChange} name="cash_paid2" placeholder="Enter Secondary Cash Amount" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="balance">Balance</label>
                                                    <input type="text" class="form-control" value={formData.balance} onChange={handleInputChange} name="balance" placeholder="Enter Balance" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="finance">Finance</label>
                                                    <input type="text" class="form-control" value={formData.finance} onChange={handleInputChange} name="finance" placeholder="Enter Finance" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="emi_tenure">EMI / Tenure</label>
                                                    <input type="text" class="form-control" value={formData.emi_tenure} onChange={handleInputChange} name="emi_tenure" placeholder="Enter EMI / Tenure" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="bank_name">Bank Name</label>
                                                    <input type="text" class="form-control" value={formData.bank_name} onChange={handleInputChange} name="bank_name" placeholder="Enter Bank Name" />
                                                </div>
                                            </div>
                                        </div>

                                        <hr class="divider"></hr>

                                        <label for="from">Exchange Details:</label>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="exchange_of">Exchange Of</label>
                                                    <input type="text" class="form-control" value={formData.exchange_of} onChange={handleInputChange} name="exchange_of" placeholder="Enter Exchange Of" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="exchange_amout">Exchange Amount</label>
                                                    <input type="text" class="form-control" value={formData.exchange_amout} onChange={handleInputChange} name="exchange_amout" placeholder="Enter Amount" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="exchange_reg_no">Exchange Registration No</label>
                                                    <input type="text" class="form-control" value={formData.exchange_reg_no} onChange={handleInputChange} name="exchange_reg_no" placeholder="Enter Registration No" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="exchange_bike_model">Exchange Bike Model</label>
                                                    <input type="text" class="form-control" value={formData.exchange_bike_model} onChange={handleInputChange} name="exchange_bike_model" placeholder="Enter Bike Model" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="exchange_bike_make">Exchange Bike Make</label>
                                                    <input type="text" class="form-control" value={formData.exchange_bike_make} onChange={handleInputChange} name="exchange_bike_make" placeholder="Enter Bike Make" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="exchange_bike_color">Exchange Bike Color</label>
                                                    <input type="text" class="form-control" value={formData.exchange_bike_color} onChange={handleInputChange} name="exchange_bike_color" placeholder="Enter Bike Color" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="exchange_bike_chase_no">Exchange Chase No</label>
                                                    <input type="text" class="form-control" value={formData.exchange_bike_chase_no} onChange={handleInputChange} name="exchange_bike_chase_no" placeholder="Enter Chase No" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="exchange_bike_engine_no">Exchange Engine No</label>
                                                    <input type="text" class="form-control" value={formData.exchange_bike_engine_no} onChange={handleInputChange} name="exchange_bike_engine_no" placeholder="Enter Engine No" />
                                                </div>
                                            </div>
                                        </div>

                                        {["aadhar_file", "rc_file", "photo_file", "photowithbike_file"].map((field) => (
                                            <div key={field} className="form-group">
                                                <label htmlFor={field}>
                                                    {field.replace("_file", "").toUpperCase()}
                                                </label>
                                                <div className="input-group">
                                                    <div className="custom-file">
                                                        <input
                                                            type="file"
                                                            className="custom-file-input"
                                                            id={field}
                                                            onChange={handleFileChange}
                                                            accept=".pdf,.jpg,.jpeg,.png"
                                                        />
                                                        <label className="custom-file-label">
                                                            {files[field] ? files[field].name : "Choose file"}
                                                        </label>
                                                    </div>
                                                </div>
                                                {errors[field] && <small className="text-danger">{errors[field]}</small>}
                                            </div>
                                        ))}
                                    </div>

                                    <div class="card-footer">
                                        <button type="submit" class="btn btn-primary" onClick={savebilling} disabled={isSaving || isSaved}>{isSaved ? 'Bill Saved' : isSaving ? 'Saving...' : 'Save Bill'}</button>
                                        {/* Print and Download Buttons */}
                                        {isSaved && (
                                            <div>
                                                <button type="button" className="btn btn-secondary mb-4 mr-2" onClick={printBill} style={{ marginTop: '10px' }}>
                                                    Print
                                                </button>
                                                <button type="button" className="btn btn-success mb-4" onClick={handleClear} style={{ marginTop: '10px' }}>
                                                    clear
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </section >

            {invoiceData && (
                <div id="download_section" style={{ display: "none" }}>
                    <div className="delivery-note-container">
                        <div className="delivery-note-header">
                            <img src="dist/img/shivam.jpeg" alt="Shivam Moto Banner" className="header-image" />
                        </div>

                        <div className="delivery-note-section">
                            {/* Left Section for DN No. and Date */}
                            <div className="delivery-note-left">
                                <p><strong>Bill No:</strong>{invoiceData.bill_no}</p>
                                <p><strong>Date:</strong>{invoiceData.date}</p>
                            </div>
                            <div className="delivery-note-header">
                                <h3 className="delivery-note-title"><strong>DELIVERY NOTE</strong></h3>
                                <h3 className="delivery-note-title1">ONLY ON COMMISSION BASIS</h3>
                            </div>

                            {/* Right Section for Image */}
                            <div className="delivery-note-image">
                                <div className="delivery-note-image-container">
                                    <img src={`https://api.sivammoto.in/api/file/uploads/${fileData?.photo || ''}`} alt="Buyer" className="fixed-image" />
                                </div>
                            </div>

                        </div>

                        <div className="delivery-note-info">
                            <div>
                                <h3 className="delivery-note-fromto"><span className="highlight-text">From</span>:</h3>
                                <p><strong><b>{invoiceData.from_name}</b></strong></p>
                                <p>{invoiceData.from_address1}</p>
                                <p>{invoiceData.from_address2}</p>
                                <p>{invoiceData.from_city}</p>
                            </div>
                            <div>
                                <h3 className="delivery-note-fromto"><span className="highlight-text">To</span>:</h3>
                                <p><strong><b>{invoiceData.to_name}</b></strong></p>
                                <p>{invoiceData.to_address1}</p>
                                <p>{invoiceData.to_address2} , {invoiceData.to_city}</p>
                                <p>
                                    <strong>Phone:</strong> <strong><b>{invoiceData.to_phone1}, {invoiceData.to_phone2}</b></strong>
                                </p>
                            </div>
                        </div>

                        <div className="delivery-note-right-align">
                            <p><strong>Sir,</strong></p>
                            <div className="letter-content">
                                <p><span className="highlight-text"><strong>Ref:</strong><strong><b> {invoiceData.ref_reg_no} </b></strong>/ {invoiceData.ref_vehicle_type} {invoiceData.ref_vehicle_color}</span></p>
                                <p>
                                    I have this day purchased the above vehicle from you for the sum of Rs.<strong> <b>{invoiceData.ref_amount}</b></strong> (Rupees in Words: <strong> {invoiceData.ref_amountinwords}</strong>) and I have taken the delivery of the said vehicle to my entire satisfaction.
                                </p>
                                <p>
                                    The entire risk is being bome by me / us / from this time <strong><b>{invoiceData.ref_time}</b></strong>
                                </p>
                            </div>
                        </div>

                        <div className="delivery-note-row">
                            {/* Left: Vehicle Details */}
                            <div className="delivery-note-vehicle-details">
                                <h3 className="delivery-note-fromto"><mark className="highlight-text">Vehicle Details</mark></h3>
                                <p><strong>Make:</strong><span>{invoiceData.bike_make}</span></p>
                                <p><strong>Chase No:</strong> <span>{invoiceData.bike_chase_no}</span></p>
                                <p><strong>Engine No:</strong> <span>{invoiceData.bike_engine_no}</span></p>
                                <p><strong>EMI / Tenure:</strong><span>{invoiceData.emi_tenure}</span></p>
                                <p><strong>Exchange Of:</strong><span><strong><b>{invoiceData.exchange_of}</b></strong></span></p>
                            </div>

                            {/* Right: Payment Details */}
                            <div className="delivery-note-payment">
                                <h3 className="delivery-note-fromto"><mark className="highlight-text">Payment Details</mark></h3>
                                <p><strong>1) Payment Type:</strong><span>{invoiceData.cash_paid1} / {invoiceData.payment_type1}</span></p>
                                <p><strong>2) Payment Type:</strong><span>{invoiceData.cash_paid2} / {invoiceData.payment_type2}</span></p>
                                <p><strong>Exchange Amount:</strong><span>{invoiceData.exchange_amout}</span></p>
                                <p><strong>Balance:</strong><span>{invoiceData.balance}</span> </p>
                                <p><strong>Finance:</strong><span> {invoiceData.finance}</span></p>
                                <p><strong>Bank Name:</strong> <span>{invoiceData.bank_name}</span></p>
                            </div>
                        </div>

                        <div className="delivery-note-tamil-text">
                            <p><i className="fa fa-check-square"></i> இந்த வண்டியை தற்பொழுது இருக்கும் நிலையில் வாங்க சம்மதிக்கிறேன்.</p>
                            <p><i className="fa fa-check-square"></i> எந்த வித ரிப்பேர் செலவு வந்தாலும் நிர்வாகம் பொறுப்பல்ல.</p>
                            <p><i className="fa fa-check-square"></i> வண்டியை எடுத்துச் சென்ற பின் எந்தவித காரணத்தை கொண்டும் திருப்பி எடுத்துக் கொள்ளப்பட மாட்டாது.</p>
                            <p><i className="fa fa-check-square"></i> வண்டி வாங்கிய 15 நாட்களுக்குள் பெயர் மாற்றிக்கொள்ள வேண்டும்.</p>
                        </div>

                        <div className="delivery-note-signatures">
                            <div>
                                <p>
                                    <strong>Signature of Dealer</strong>
                                </p>
                            </div>
                            <div>
                                <p>
                                    <strong>Signature of Buyer</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div >

    )

}

export default Billing